<template>
  <div id="app">
    <el-config-provider :locale="zhCn">
      <router-view />
    </el-config-provider>
  </div>
</template>

<script setup lang="ts">
import zhCn from 'element-plus/dist/locale/zh-cn.min.mjs'
import { useAuthStore } from '@wlink/commons/auth'
import { onMounted } from 'vue'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n';
const { locale } = useI18n()
const languageOptions = ref<Record<string, any>>({
  'zh-CN': zhCn,
})

const authStore = useAuthStore()

onMounted(() => {
  // 初始化认证状态
  authStore.initAuth()
})
</script>

<style>
#app {
  height: 100%;
}
</style>
